/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
  Input,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import ModalConfirmation from 'components/ModalConfirmation';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import {
  getEstadosGlobales,
  getTiposDeEmpleados,
  getRiesgosDePuestos,
} from 'api/catalogos/index';
import {
  getTabuladoresGenerales,
} from 'api/nominas/tabuladores/tabuladoresGenerales';
import {
  getPuestos,
  postPuesto,
  deletePuesto,
  patchPuesto,
  getPuesto,
  autorizarPuestos,
} from 'api/catalogos/puestos';
import {
  getCategoriasDePuestos,
} from 'api/catalogos/categoriaDePuestos';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import {
  ESTATUS_AUTORIZADO,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';

export const puestosPermission = {
  permissionModel: 'puesto',
  catalogsModels: [
    'tipodecontratacion',
    'categoriadepuesto',
  ],
  tabsModels: [],
};

const baseURI = 'estructura-organizacional/puesto';

const NivelSalarial = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [, setTiposEmpleados] = useState([]);
  const [estados, setEstados] = useState([]);
  const [, setCategorias] = useState([]);
  const [riesgos, setRiesgos] = useState([]);
  const [, setTabuladores] = useState();
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [, setConfirmationVisibleEstatus] = useState(false);
  const [disableAuth, setDisableAuth] = useState(false);

  const formInstances = [
    form,
    formDatos,
  ];
  const fetchData = async () => {
    setLoading(true);
    const _data = await getPuestos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tiposEmpleados,
        _categorias,
        _riesgos,
        _tabuladores,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getCategoriasDePuestos({ estados_globales: ESTATUS_AUTORIZADO }),
        getRiesgosDePuestos(),
        getTabuladoresGenerales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPuestos(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposEmpleados(_tiposEmpleados);
        setCategorias(_categorias);
        setRiesgos(_riesgos);
        setTabuladores(_tabuladores);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    // setDisableFields(false);
    setSelectedRowKeys([]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _puesto = await getPuesto(match.id);
    if (_puesto?.estados_globales === ESTATUS_ACTIVO
      || _puesto?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (_puesto?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_puesto?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }

    if (_puesto) {
      form.setFieldsValue({
        ...formatReceived(_puesto),

      });
      form.setFieldsValue(formatReceived(_puesto));
      setVisible(true);
      formatReceived(_puesto);
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      values.vigencia_final = values.vigencia_final ? values.vigencia_final.format('YYYY-MM-DD') : null;
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchPuesto(key, values) : postPuesto(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePuesto(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    // const isAutorizado = record?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = record?.estados_globales === ESTATUS_INACTIVO;
    setDisableAuth(isInactivo);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar el nombramiento');
        return;
      }
      const saved = await autorizarPuestos(key);
      if (saved) {
        const _data = await getPuestos();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Nombre del Puesto',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 200,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      render: (val) => (val ? val.format(DATE_FRONTEND_FORMAT) : ''),

      width: 100,
    },
    // {
    //   titleText: 'Tipo de Empleado',
    //   dataIndex: 'tipo_empleado',
    //   key: 'tipo_empleado',
    //   width: 200,
    //   render: (val) => tiposEmpleados.find((e) => e.id === val)?.descripcion,
    // },
    // {
    //   titleText: 'Categoría',
    //   dataIndex: 'categoria',
    //   key: 'categoria',
    //   width: 200,
    //   render: (val) => categorias.find((e) => e.id === val)?.nombre,
    // },
    // {
    //   titleText: 'Tabulador General',
    //   dataIndex: 'id',
    //   key: 'id',
    //   width: 200,
    //   render: (val) => {
    //     const _tabulador = tabuladores.find((e) => e.puesto === val);
    //     return _tabulador?.clave ? `${_tabulador?.clave} - ${_tabulador?.nombre}` : '';
    //   },
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="Puestos"
            allowImport
            baseURI={baseURI}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
              || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'puesto', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  //   || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Puesto`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                allowSave={!selectedRowKeys?.length || !disableAuth}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    rules={rules.clave}
                    label="Clave"
                    hasFeedback
                  >
                    <Input.TextArea
                      allowClear
                      disabled={
                        form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                        || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="descripcion"
                    label="Nombre del Puesto"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Input
                      maxLength={350} // <-- Aquí se define el límite
                      showCount // <-- Muestra el contador (ej: 0/350)
                      disabled={
                        form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                        || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                      }
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_empleado"
                    label="Tipo de Empleado"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      mode="multiple"
                      dataSource={tiposEmpleados}
                      onChange={(value) => {

                        if (value && value.length > 0) {
                          setTipoEmpleado(value);
                          setDisableCategoria(false);
                        } else {
                          setTipoEmpleado(null);
                          setDisableCategoria(true);
                        }

                        form.resetFields(['categoria']);
                      }}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col> */}
                {/*
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="categoria"
                    label="Categoría"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="nombre"
                      dataSource={categorias}
                      disabled={disableCategoria || estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col> */}
                {/* <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Tabulador General"
                  >
                    <Input
                      allowClear
                      disabled
                      value={tabuladorGeneral ? `${tabuladorGeneral?.clave} - ${tabuladorGeneral?.nombre}` : ''}
                    />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="riesgo_puesto"
                    label="Riesgo de Puesto"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={riesgos}
                      disabled={
                        form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                        || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                      }
                    />
                  </Form.Item>
                </Col>
                {/**
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_reloj_checador"
                    label="Aplica Reloj Checador"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={
                        form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                        || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_horario_especial"
                    label="Aplica Horario Especial"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={
                        form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                        || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                      }
                    />
                  </Form.Item>
                </Col>
                */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                    hasFeedback
                  >
                    <DatePicker
                      placeholder=""
                      format="DD/MM/YYYY"
                      disabled={form.getFieldValue('estados_globales') !== ESTATUS_AUTORIZADO}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.required}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Puesto ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Puesto ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default NivelSalarial;
